var tempthat = {};
var DetailController = (function () {
    function DetailController(env, $filter, DTS, $scope, $stateParams, $state, socket, topic, $mdIcon, config, status, //probably temp
        Dialog, $mdDialog, settings, searchSubmit, $rootScope) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.topic = topic;
        this.$mdIcon = $mdIcon;
        this.config = config;
        this.status = status;
        this.Dialog = Dialog;
        this.$mdDialog = $mdDialog;
        this.settings = settings;
        this.searchSubmit = searchSubmit;
        this.$rootScope = $rootScope;
        this.allMessage = 'all';
        this.comp = 'status';
        this.loadingUsers = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.incentiveProgramsConfig = {
            cvrSSA: false,
            solution: false,
            growthIncentive: false,
            salesIncentive: false,
            engagement: false,
            focusIncentive: false,
            specialBid: false,
            NC: false
        };
        this.isIncentivesEmpty = true;
        //console.log(topic); // LOSE THIS AT SOME POINT - HANDY FOR NOW, THOUGH!
        this.id = $stateParams.id;
        topic.setActiveTab(this.$state.current.name);
        if (angular.isDefined(this.$state.current) && this.$state.current.name === 'detail.searchsubmit') {
            topic.setActiveTab('detail.searchsubmit');
        }
        this.showstatusSave = false;
        this.$rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
            tempthat['viewLoaded'] = true;
            _this.saasFlag = (_this.topic.topic.sales_assist && _this.topic.topic.sales_assist.type) ? _this.topic.topic.sales_assist.type : 'Automatic';
        });
        socket.forward('history.exist', $scope);
        this.$scope.$on('socket:history.exist', function (event, res) {
            //console.log(`TMP - on history.exist:  ${new Date(Date.now())}`);
            _this.historyLoaded = true;
            var preparedDB2Data = _this.prepareESDB2HistoryData(res.history.db2Results.data);
            _this.topic.esDB2History = {
                error: res.history.db2Results.isError,
                data: preparedDB2Data
            };
            _this.topic.esCouchHistory = {
                error: res.history.couchResults.isError,
                data: res.history.couchResults.data
            };
        });
        socket.forward('detail.setIncentivePrograms', $scope);
        this.$scope.$on('socket:detail.setIncentivePrograms', function (event, data) {
            //console.log(`TMP - on detail.setIncentivePrograms:  ${new Date(Date.now())}`);
            for (var key in _this.incentiveProgramsConfig) {
                if (_this.incentiveProgramsConfig.hasOwnProperty(key)) {
                    _this.incentiveProgramsConfig[key] = data.incentiveProgramsConfig[key] || false;
                }
            }
            var NC = _.get(_this.topic, 'checksData.result.NC.data.ncDecision', false);
            _this.incentiveProgramsConfig.NC = NC;
            _this.isIncentivesEmpty = Object.keys(_this.incentiveProgramsConfig).every(function (key) { return !_this.incentiveProgramsConfig[key]; });
            _this.uiVersion = _.get(_this.topic, 'topic.version');
        });
    }
    DetailController.prototype.getAvatar = function () {
        return this.DTS.getAvatar(this.topic.topic.owner, 115);
    };
    DetailController.prototype.prepareESDB2HistoryData = function (data) {
        return data.reduce(function (currentResult, elem) {
            var createdTime = elem.CREATED;
            if (elem.ACTIVE === 'active') {
                return currentResult = currentResult.concat([{
                        esRequestId: "" + elem.ES_REQUEST_ID_ALIAS,
                        eventText: "Created for " + elem.STAGE + " stage",
                        time: createdTime
                    }]);
            }
            var closedTime = elem.UPDATED;
            return currentResult = currentResult.concat([{
                    esRequestId: "" + elem.ES_REQUEST_ID_ALIAS,
                    eventText: "Created for " + elem.STAGE + " stage",
                    time: createdTime
                }, {
                    esRequestId: "" + elem.ES_REQUEST_ID_ALIAS,
                    eventText: "Closed for " + elem.STAGE + " stage",
                    time: closedTime
                }]);
        }, []);
    };
    /**
     * Function to collect the correct title to be displayed when someone hovers over the approval flag icon
     *
     * @returns {string}
     * @memberof DetailController
     */
    DetailController.prototype.getApprovalTitle = function () {
        var amountUSD = 'Awaiting Calculations';
        var amountLC = 'Awaiting Calculations';
        var currLC = '???';
        // Currency...if GOE then take Forcast Currency, otherwise Sales Order Currency
        // TODO: update for calculation v2
        if (angular.isDefined(this.topic.topic.calculation)) {
            currLC = angular.isDefined(this.topic.topic.calculation.bonusTotalCurr) ? this.topic.topic.calculation.bonusTotalCurr : '???';
            amountUSD = this.topic.topic.status.approvals.approval_amount !== 0 ? this.$filter('number')(this.topic.topic.status.approvals.approval_amount, 2) : 'Awaiting Calculations';
            amountLC = angular.isNumber(this.topic.topic.calculation.bonusTotal) ? this.$filter('number')(this.topic.topic.calculation.bonusTotal, 2) : 'Awaiting Calculations';
        }
        // Create display showing the approval amount in USD (vital) and LC (for fun)
        var aa = '\n\nApproval Amount (USD): ' + amountUSD;
        if (currLC !== 'USD') {
            aa += '\nApproval Amount (' + currLC + '): ' + amountLC;
        }
        // If approval required but not complete
        if (this.topic.topic.status.approvals.approval_required && !this.topic.topic.status.approvals.complete) {
            return 'This Disbursement will require Approval should it need to be Paid because it is' +
                ' not \'Touchless\', ie: there has been manual intervention during either the Validation ' +
                'or Calculation stages, or both, or the payment amount has exceeded the Bonus Clip for the Geo.' + aa +
                '\n\nReason(s): \n---------------------------------------------\n' +
                this.topic.topic.status.approvals.approval_reason;
        }
        else if (!this.topic.topic.status.approvals.approval_required) {
            return 'This Disbursement would have required Approval, but the flag was removed by System Admin.' +
                '\n\nReversal Comment: ' +
                this.topic.topic.status.approvals.approval_reason;
        }
        else if (this.topic.topic.status.approvals.complete) {
            return 'This Disbursement was Approved since it was' +
                ' not \'Touchless\', ie: there had been manual intervention during either the Validation ' +
                'or Calculation stages, or both, or the payment amount has exceeded the Bonus Clip for the Geo.' + aa +
                '\n\nReason(s): \n---------------------------------------------\n' +
                this.topic.topic.status.approvals.approval_reason;
        }
    };
    DetailController.prototype.$onInit = function () {
        this.historyLoaded = false;
        this.id = this.$stateParams.id; //ie: the value on display in the queue...could be opp or opp + disputenumber
        this.unid = this.id.indexOf('DMT-') === 0 ? this.id : "DMT-" + this.id; //the full DMT unique ref...same as above but with DMT- at the front
        var opp = this.id;
        this.topic.esDB2History = {
            error: false,
            data: []
        };
        this.topic.esCouchHistory = {
            error: false,
            data: []
        };
        //If a dispute..
        var dispute = this.id.indexOf('-DIS:');
        if (dispute > -1) {
            //Strip the dispute details from the id so it's just the opp
            opp = this.id.substring(0, dispute);
        }
        /*if (!this.topic.loaded.topic) {
          this.$state.go('loading', {
              id: this.id
          });
        }*/
        //this.topic.tabs.list[3].editable = (this.topic.topic.sampling.samplingStatus === 'active');
        //console.log(`TMP - onInit:  ${new Date(Date.now())}`);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'extractHistory',
                script: '/engage-support/history/extractESHistory',
                data: {
                    //DMT-1341 - to show own log (not the parent one)
                    opportunityId: this.id
                },
                token: this.env.user.token
            }
        });
        this.searchSubmit.updateResults(undefined);
        this.searchSubmit.updateOriginal(undefined);
        this.searchSubmit.updateLaterProcess(false);
        if (tempthat['viewLoaded']) {
            if ((angular.isDefined(this.id)) && (angular.isUndefined(this.topic.reloadCheck.topicBrowserID) ||
                angular.isUndefined(this.topic.reloadCheck.id) || angular.isUndefined(this.topic.topicBrowserID) ||
                (this.id !== this.topic.reloadCheck.id))) {
                this.topic.clearTopic(this.id);
                //console.log(`TMP - onInit - viewLoaded - loadData:  ${new Date(Date.now())} - ${this.unid}`);
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'loadDataClient',
                        script: '/detail/general/general',
                        data: {
                            opp: opp,
                            unid: this.unid
                        },
                        token: this.env.user.token
                    }
                });
            }
            else if (angular.isDefined(this.id) && this.id === this.topic.reloadCheck.opp) {
                this.topic.updateTopic([], false, []);
            }
        }
    };
    // Once change of the tab, disable edit mode, active tab, set if it can be editable and move to the correct tab.
    DetailController.prototype.goTo = function (tab) {
        //this.topic.setEditable(tab.editable);
        //this.topic.setEditMode(false);
        if (angular.isDefined(this.$state.current) && this.$state.current.name === 'detail.searchsubmit') {
            this.topic.updatePartialSocketStatus([this.searchSubmit.type], '');
        }
        this.topic.setActiveTab(tab.name);
        //console.log('activetab set to ' + tab.name);
        this.$state.go(tab.name, this.$stateParams);
    };
    // When action = edit- enable editing & change to edit component,
    //save- save values to topic, move back to non-edit mode, ""- moves back to non-edit mode
    DetailController.prototype.changeEditMode = function (link, action) {
        console.log('edit change: ' + link + ' > ' + action + ' > ' + this.topic.tabs.editPath + ' > ' + this.topic.getEditable());
        if (action === 'save') {
            // Check if we can update the values if yes continue to update temp
            this.topic.setTopicFromTemp();
        }
        if (action === this.topic.tabs.editPath && this.topic.getEditable()) {
            this.topic.setTempFromTopic();
            //this.topic.setEditMode(true);
            this.$state.go(link + action, this.$stateParams);
        }
        else {
            //this.topic.setEditMode(false);
            this.$state.go(link, this.$stateParams);
        }
    };
    DetailController.prototype.setSalesAssistSub = function () {
        if (angular.isDefined(this.topic.topic.sap) && this.topic.topic.sap.length > 0 && angular.isDefined(this.topic.topic.sap[0].mdlTypeCode)) {
            if (this.topic.topic.sap[0].mdlTypeCode === 'ML') {
                return 'Monthly License';
            }
            else if (this.topic.topic.sap[0].mdlTypeCode === 'SS') {
                return 'SaaS';
            }
            else {
                return 'License Unknown';
            }
        }
        else {
            return 'License TBC';
        }
    };
    DetailController.prototype.showStatusSaveButton = function () {
        if (this.topic.topic_ext.sub_status !== this.topic.temp_ext.sub_status && !this.status.mainStatusChange) {
            this.showstatusSave = true;
        }
        else {
            this.showstatusSave = false;
        }
        //If new status is a system-set status...still show but disable
        /* let sub = this.config.getSubStatusByDesc(this.topic.topic.status.status_no, this.topic.temp_ext.sub_status);
               if (sub !== null && angular.isDefined(sub.system) && sub.system) {
                   this.disableStatusSave = true;
               } else {
                   this.disableStatusSave = false;
               }*/
    };
    DetailController.prototype.saveStatus = function (action, comments) {
        // This needs to be changed in order for the substatus to work nicely
        this.topic.sendForUpdate(['status'], action, comments, false);
        console.log('Sending for update status');
        this.showstatusSave = false;
    };
    DetailController.prototype.viewApprovers = function (event) {
        var _this = this;
        // Get the config
        var err = null;
        //if (angular.isUndefined(this.config.tempData)) {
        if (angular.isUndefined(this.settings.status_cfg)) {
            err = 'CONFIG';
        }
        var bundle = { expand: false, show: 'Show' };
        //Find the relevant approval package based on status/sub-status
        var appStage = this.config.getSubStatusBySubStatusNo2(this.topic.topic.status.status_no, this.topic.topic.status.sub_status_no);
        bundle.selectedApprover = {
            name: this.topic.topic.status.approvals.selected_approver_name,
            email: this.topic.topic.status.approvals.selected_approver_email
        };
        bundle.status = this.topic.topic_ext.status;
        bundle.sub_status = this.topic.topic_ext.sub_status;
        bundle.owner_email = this.topic.topic.owner;
        var roleNumber = 0;
        if (appStage.peer) {
            if (appStage.bpso) {
                bundle.team = 'BPSO Administration Team';
            }
            else {
                bundle.team = 'Non-BPSO Administration Team';
                roleNumber = 1;
            }
            bundle.peer = true;
            if (this.topic.topic.owner === this.env.user.email) {
                bundle.owner = 'you';
            }
            else {
                bundle.owner = 'the Assignee';
            }
        }
        else {
            bundle.approvers = [];
            bundle.approvers = appStage.users;
            bundle.peer = false;
            if (appStage.bpso) {
                bundle.team = 'BPSO Approvers';
            }
            else {
                bundle.team = 'Non-BPSO Approvers';
            }
        }
        //Get them
        if (!appStage.users || !bundle.approvers) {
            this.loadingUsers = true;
            this.status.newPromise(this.socket, roleNumber, this.topic.topic.country).then(function (theUsers) {
                _this.loadingUsers = false;
                bundle.approvers = theUsers;
                appStage.users = theUsers;
                _this.viewApproversExe(event, bundle, err);
            }, function (noUsersReturnedInTime) {
                _this.loadingUsers = false;
                err = 'USERS';
                _this.viewApproversExe(event, bundle, err);
            });
        }
        else {
            this.viewApproversExe(event, bundle, err);
        }
    };
    DetailController.prototype.viewApproversExe = function (event, bundle, err) {
        //People who have already approved as the Assignee should be able to approve
        bundle.excludeList = angular.isDefined(this.topic.topic.status.approvals.approvers) ? this.topic.topic.status.approvals.approvers.concat([this.topic.topic.owner]) : [this.topic.topic.owner]; //Previous approvers and assignee                
        var title = 'The following users have already approved during the current Approval Process:\n';
        for (var i = 0; i < bundle.excludeList.length - 1; i++) {
            title += '\n# ' + (i + 1) + ' ' + bundle.excludeList[i];
            if (i === 0) {
                title += ' - (initiated by)';
            }
        }
        bundle.approvers = this.status.cleanApprovers(bundle.approvers, bundle.excludeList);
        bundle.prevApprovers = title;
        this.items = {
            bundle: bundle,
            error: err,
            toggleApprovers: (function () {
                if (bundle.expand) {
                    bundle.expand = false;
                    bundle.show = 'Show';
                }
                else {
                    bundle.expand = true;
                    bundle.show = 'Hide';
                }
            })
        };
        //if no approvers for a stage
        if (bundle.approvers.length === 0) {
            this.items.error = 'NOAPPS';
        }
        this.Dialog.openDialog(event, this.items, DialogService, 'stage-approvers.html');
    };
    DetailController.prototype.viewCycleTimes = function (event) {
        //Work out days and owner from last history to now
        var statusObject = angular.copy(this.topic.topic.status);
        statusObject = this.status.calculateOwnership(statusObject);
        var e2e = 0;
        angular.forEach(statusObject.cycle_times, function (cycle) {
            for (var key in cycle) {
                if (cycle.hasOwnProperty(key)) {
                    e2e = e2e + cycle[key];
                }
            }
        });
        //Loop from back to front until an entry is found where owner is not -
        var historyObj;
        for (var i = statusObject.history.length - 1; i >= 0; i--) {
            historyObj = statusObject.history[i];
            //If entry is not blank (pff) or -
            if (['', '-'].indexOf(historyObj.new_owner) === -1) {
                break;
            }
        }
        //Current owner
        var owner = historyObj.new_owner; //ie:  Billing, BPSO etc
        //If claim is at the end of the process, ie: Paid, Rejected or closed, get that date from the history
        // otherwise use today's date
        var endDate;
        if (this.topic.isComplete()) {
            var statusDesc = this.config.getMainStatusByMainStatusNo(this.topic.topic.status.status_no).txt;
            for (var i = statusObject.history.length - 1; i >= 0; i--) {
                historyObj = statusObject.history[i];
                if (historyObj.event === statusDesc) {
                    break;
                }
            }
            endDate = new Date(historyObj.timestamp);
        }
        else {
            endDate = new Date(); //now
        }
        //Get date period
        var dates = { startDate: this.topic.topic.status.history[0].timestamp, endDate: endDate };
        this.items = {
            dates: dates,
            cycles: statusObject.cycle_times,
            columnHeaders: ['Cycle Owner Team', 'No. of Days', ''],
            totalDays: e2e,
            currentOwner: owner
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'cycle-times.html');
    };
    DetailController.prototype.viewEngageSupportHistory = function (event) {
        this.esItems = {
            dataDB2: this.topic.esDB2History,
            db2ColumnHeaders: ['ES request number', 'Event', 'Date & Time'],
            dataCouch: this.topic.esCouchHistory,
            couchColumnHeaders: ['Action', 'Message', 'Date & Time']
        };
        this.Dialog.openDialog(event, this.esItems, DialogService, 'es-history.html');
    };
    DetailController.prototype.viewRejectionDetails = function (event) {
        this.items = {
            reject_status: this.config.getMainStatusByMainStatusNo(this.topic.topic.status.rejection_details.reject_status).txt,
            rejection_details: this.topic.topic.status.rejection_details
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'rejection-details.html');
    };
    DetailController.prototype.viewClosureDetails = function (event) {
        this.items = {
            close_status: this.config.getMainStatusByMainStatusNo(this.topic.topic.status.close_details.close_status).txt,
            close_details: this.topic.topic.status.close_details
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'closure-details.html');
    };
    DetailController.prototype.viewProgramProfile = function (event) {
        var err = null;
        if (this.config.proProfile !== undefined) {
            if (angular.isString(this.config.proProfile) && this.config.proProfile.indexOf('ERROR:') > -1) {
                err = this.config.proProfile;
            }
        }
        else {
            err = 'ERROR: System issue trying to retrieve the Program Profile';
        }
        this.items = {
            cfg: this.config,
            process_statuses: this.config.getProgramStatusFlow(this.topic.topic.program),
            error: err,
            convert: function (object) {
                var newValue = '';
                if (angular.isArray(object)) {
                    if (object.length > 0) {
                        angular.forEach(object, function (value) {
                            if (angular.isDefined(value)) {
                                newValue = newValue + ' ' + value;
                            }
                        });
                    }
                    else {
                        return 'N/A';
                    }
                }
                else {
                    newValue = object.length > 0 ? object.replace('_', ' ') : 'N/A';
                }
                return newValue.trim().toUpperCase();
            }
        };
        this.Dialog.openDialog(event, this.items, DialogService, 'program-profile.html');
    };
    DetailController.prototype.showSearchResults = function () {
        this.$state.go('detail.searchsubmit', {
            id: this.$stateParams.id
        });
    };
    /**
     * returns label for Sales, depending on oppty version
     * @returns {string}
     */
    DetailController.prototype.getSalesLabel = function () {
        var version = this.topic.checksData.uiVersion;
        var type = (this.topic.topic.sales_assist && this.topic.topic.sales_assist.type) ? this.topic.topic.sales_assist.type : undefined;
        if (!version || version < this.OPP_VERSION_3) {
            return type || 'Automatic';
        }
        else if (version === this.OPP_VERSION_3) {
            return type || 'CVR SSA';
        }
        else if (version >= this.OPP_VERSION_4) {
            if (!type || type === 'CVR SSA') {
                return 'Sales/Sales Assist';
            }
            else if (type === 'CVR Sales') {
                return 'Sales';
            }
            else if (type == 'CVR Sales Assist') {
                return 'Sales Assist';
            }
            else {
                return type;
            }
        }
    };
    /**
     * Returns CVR or SWDR based on oppy version
     * @returns {string}
     * @memberof DetailController
     */
    DetailController.prototype.getProgramType = function () {
        if (this.topic.checksData.uiVersion >= this.OPP_VERSION_3) {
            return 'SWDR';
        }
        else if (this.topic.topic.program === 'SVI') {
            return 'CVR';
        }
        else {
            return this.topic.topic.program;
        }
    };
    DetailController.$inject = ['env', '$filter', 'DTS', '$scope', '$stateParams', '$state',
        'socket', 'topic', '$mdIcon', 'config', 'status', 'Dialog', '$mdDialog', 'settings',
        'searchSubmit', '$rootScope', '_'];
    return DetailController;
}());
var DetailComponent = (function () {
    function DetailComponent() {
        this.templateUrl = 'detail.html';
        this.controllerAs = 'vm';
        this.controller = DetailController;
    }
    return DetailComponent;
}());
angular
    .module('application')
    .component('detailSection', new DetailComponent());

//# sourceMappingURL=detail.component.js.map
